import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useFetchHTMLContent from '../../hooks/use-fetch-content';
import BackToTop from '../back-to-top';
import InlineComponents from '../inline-components';
import { Box, BoxArtigo, Container, ContentTitle, TitleContainer, BorderContainer } from './styles';
import {
  BoxTitle,
  Header,
} from '../article-header/styles';
import { useSubjectsContext } from '../../contexts/SubjectsContext';
import getContentPagePath from '../../utils/get-content-page-path';
import getContentPageTitle from '../../utils/get-content-page-title';
import { ReactComponent as ArticleTitleBorder } from '../../assets/image/articleTitleBorder.svg';
import NavigationButtons from '../navigation-buttons';

type Props = {
  sidebar: boolean;
};

export default function ArticleLayout({ sidebar }: Props) {
  const { subject, page, section } = useParams();
  const subjects = useSubjectsContext();
  const url = (section
    ? `${subject}/${page}/${section}`
    : `${subject}/${page}`);
  const subjectTitleParts = getContentPageTitle(subjects, url);

    if (!subject || !page) {
    return <p>Conteúdo não encontrado</p>;
  }

  const htmlFileString = useFetchHTMLContent(
    getContentPagePath(subjects, subject, page, section),
    subject,
    page,
  );

  const scrollToTop = () => {
    if (window) window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToTop();
  }, [subject, page, section]);

  return (
    <Box $sidebar={sidebar}>
      <Container>
        {subjectTitleParts && (
          <Header className="header">
            { subjectTitleParts.parentTitle && (
              <ContentTitle $color={20} $subject="">
                {
                  (subjectTitleParts.grandParentTitle) &&
                    (
                      <>
                        <span className="breadcrumb__parent">
                          {
                            (subjectTitleParts.grandParentTitle ?
                              subjectTitleParts.grandParentTitle :
                              subjectTitleParts.parentTitle
                            )
                          }
                        </span>
                        <span style={{ fontSize: '1.25rem' }}>&gt;</span>
                      </>
                    )
                }
                <span className="breadcrumb__item">{(subjectTitleParts.parentTitle ? subjectTitleParts.parentTitle : subjectTitleParts.title)}</span>
              </ContentTitle>
            )}
            <BoxTitle $color={20} $subject="">
              <TitleContainer>
                <h1 className="titulo">
                  {subjectTitleParts.title}
                </h1>
                {subjectTitleParts.subtitle && <h2 className="subtitulo">{subjectTitleParts.subtitle}</h2>}
              </TitleContainer>
              <BorderContainer>
                <ArticleTitleBorder />
              </BorderContainer>
            </BoxTitle>
          </Header>
        )}
        <BoxArtigo $color={20} $subject="">
          <InlineComponents
            htmlFileString={`${htmlFileString}`}
          />
        </BoxArtigo>
        <NavigationButtons />
        <BackToTop onButtonClick={scrollToTop} />
      </Container>
    </Box>
  );
}
